import { fromJS } from "immutable";

export const updateOnlyUpdatedProps = (initial, updated) => {
  const initialToJS = initial.toJS();
  const updatedToJS = updated.toJS();

  const initialKeys = Object.keys(initialToJS);
  const updatedKeys = Object.keys(updatedToJS);
  const differentKeys = initialKeys.filter(
    initialKey => !updatedKeys.some(updatedKey => updatedKey === initialKey)
  );

  return fromJS({
    ...differentKeys.reduce(
      (prev, current) => ({
        ...prev,
        [current]: initialToJS[current],
      }),
      {}
    ),
    ...updatedToJS,
  });
};
